export default __webpack_public_path__ + "static/media/pause.0510d7ce.svg";